module.exports = __webpack_public_path__ + "img/fish4.91852ae4.png";